<div class="row">
  <div class="col-sm-6">
    <div style="text-align: right;"  *ngIf="WriteAction">
      <button mat-raised-button color="primary" (click)="add()">
        Add
      </button>
    </div>
    <table mat-table matSort [dataSource]="dataSource" style="width: 100%;">
      <ng-container matColumnDef="emailType">
        <th mat-header-cell mat-sort-header *matHeaderCellDef> Email Type </th>
        <td mat-cell *matCellDef="let element">
          {{element.emailType}}
        </td>
      </ng-container>
      <ng-container matColumnDef="email">
        <th mat-header-cell mat-sort-header *matHeaderCellDef> Email </th>
        <td mat-cell *matCellDef="let element">
          {{element.email}}
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row [ngClass]="{'row_select': row.personEmailId === this.personEmail.personEmailId }"
        *matRowDef="let row; columns: displayedColumns;" (click)="edit(row)"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons></mat-paginator>
  </div>
  <div class="col-sm-6" *ngIf="isShown">
    <div [formGroup]="emailFormGroup">
      <div style="text-align: right;"  *ngIf="WriteAction">
        <button mat-raised-button color="primary" [disabled]="!emailFormGroup.valid" (click)="onSubmit()">
          {{this.personEmail && this.personEmail.personEmailId !== null ? 'Update': 'Save'}}
        </button>
        &nbsp;
        <button mat-raised-button (click)="cancel()">
          Cancel
        </button>
        &nbsp;
        <button color="warn" *ngIf="this.personEmail && this.personEmail.personEmailId !== null"
          (click)="delete(this.personEmail.personEmailId)" mat-raised-button (click)="cancel()">
          Delete
        </button>
      </div>
      <br>
      <mat-divider></mat-divider>
      <br>
      <div class="row"  [ngClass]="{disabledDiv: !WriteAction}">
        <div class="col-sm-6">
          <mat-form-field [hidden]="true">
            <input matInput formControlName="personEmailId">
          </mat-form-field>
          <mat-form-field style="display:flex;flex-direction: column">
            <mat-label>Email Type</mat-label>
            <mat-select required formControlName="emailTypeId">
              <mat-option>--SELECT--</mat-option>            
              <ng-container *ngFor="let item of emailTypeList">
                <mat-option *ngIf="evalBind(item,personEmail.emailTypeId)" [value]="item.id">
                    {{item.description}}
                </mat-option>
              </ng-container> 
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-sm-6">
          <mat-form-field style="display:flex;flex-direction: column">
            <mat-label>Email</mat-label>
            <input matInput required [pattern]="emailPattern" placeholder="Email" maxlength="150" formControlName="email">
          </mat-form-field>
        </div>       
      </div>
    </div>
  </div>
</div>